import { Reveal } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What happens after I request a consultation?",
    a: "Coach Jean Claude personally reaches out within 24 hours to learn about your goals, answer questions, and map out the best plan for you. No pressure, no obligation.",
  },
  {
    q: "Where are you located?",
    a: "In-person coaching and bootcamps run at two Scarborough locations — Synergy Fitness (1703 Victoria Park Ave, Unit 2) and Afterburn Performance (230 Nantucket Blvd #1). Online and hybrid coaching are available anywhere.",
  },
  {
    q: "I'm a complete beginner — is this for me?",
    a: "Absolutely. Every program scales to your level. Whether you've never trained before or you're returning after a long break, we start where you are and build from there — technique first, always.",
  },
  {
    q: "What's the difference between In-Person, Hybrid and Online coaching?",
    a: "In-Person is fully hands-on 1-on-1 training. Hybrid blends in-person sessions with app-based programming, check-ins and messaging. Online is fully remote coaching through the GFWJC app with weekly check-ins — ideal if you prefer to train on your own schedule.",
  },
  {
    q: "Do you offer payment plans?",
    a: "Yes. Flexible payment plans are available, and Afterpay can be used on eligible coaching and bootcamp packages so you can spread payments over time while starting right away.",
  },
  {
    q: "Can I pause or cancel my package?",
    a: "Life happens — just reach out and we'll work with you to pause or adjust your plan. We want your coaching to fit your life, not the other way around.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-[#050505] py-24 md:py-40 border-t border-[#222]" data-testid="faq">
      <div className="mx-auto max-w-[1100px] px-5 md:px-10">
        <Reveal className="mb-12 md:mb-16">
          <p className="font-mono-accent text-[#005EEA] text-xs mb-4">FAQ</p>
          <h2 className="font-display text-white text-5xl md:text-7xl leading-[0.9]">
            Good to know
          </h2>
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#222]" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-display text-white text-lg md:text-2xl text-left hover:text-[#005EEA] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#A0A0A0] text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
